/**
 * ERV (Energy Recovery Ventilator) Templates
 * 全熱交換器模板
 */

import { Template01_Dashboard } from './Template01_Dashboard';

export { Template01_Dashboard };

// Default export for lazy loading
export default Template01_Dashboard;

// Template registry for this device type
export const ErvTemplates = {
  Template01: Template01_Dashboard
};
